'use strict';

export default class BrandTile {

    constructor(brandTileDom, position) {
        this._dreson = brandTileDom.getAttribute("data-dreson");
        this._imageId = brandTileDom.getAttribute("data-image-id");
        this._urlPath = brandTileDom.querySelector("a").getAttribute("href");
        this._position = position;
    }

    get position() {
        return this._position;
    }

    get dreson() {
        return this._dreson;
    }

    get urlPath() {
        return this._urlPath;
    }

    get imageId() {
        return this._imageId;
    }
}